import {useState, useEffect} from 'react';
import {Platform} from 'react-native';

const isWeb = Platform.OS === 'web';

const getMatches = query => {
  // Prevents SSR issues
  if (isWeb && typeof window !== 'undefined') {
    return window.matchMedia(query).matches;
  }
  return false;
};

function useMediaQuery(query) {
  const [matches, setMatches] = useState(getMatches(query));

  useEffect(() => {
    // Hooks must run unconditionally; the platform gate lives inside the effect.
    if (!isWeb) {
      return undefined;
    }
    const matchMedia = window.matchMedia(query);

    const handleChange = () => {
      setMatches(getMatches(query));
    };

    // Triggered at the first client-side load and if query changes
    handleChange();

    // Listen matchMedia
    matchMedia.addEventListener('change', handleChange);

    return () => {
      matchMedia.removeEventListener('change', handleChange);
    };
  }, [query]);

  // Preserve the pre-refactor native return value (undefined, not false).
  return isWeb ? matches : undefined;
}

export default useMediaQuery;
